import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-background-100 p-8 md:p-16">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/5 rounded-bl-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary-500/5 rounded-tr-[100px]"></div>

          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-snug">
              所有漫画完全免费阅读
              <br />
              <em className="not-italic text-accent-500">无删减</em> 内容同步更新
              <br />
              <em className="not-italic text-primary-500">下拉式</em> 流畅体验
              <br />
              <strong className="text-foreground-800">高清</strong> 全彩画质
            </h2>

            <p className="mt-6 text-sm text-foreground-500 max-w-lg mx-auto leading-relaxed">
              无需注册、无需付费，打开浏览器即可畅享最全韩漫资源。我们承诺永久免费，将最好的韩国漫画带给每一位中文读者。
            </p>

            <Link
              to="/category/action"
              className="mt-8 inline-block px-8 py-3.5 bg-background-950 text-foreground-50 rounded-full text-sm font-label font-medium hover:bg-background-900 transition-all whitespace-nowrap cursor-pointer"
            >
              立即探索热门韩漫
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}